export const removeTokenAndRelevantInfo = () => {
  // localStorage.removeItem("role");
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("user");
  localStorage.removeItem("first_name");
  localStorage.removeItem("last_name");
};
